import {
  ATIVOSBASE_LIST,
  ATIVOSBASE_MERCADO,
  ATIVOSBASE_COTACAO,
  ATIVOSBASE_READ,
  ATIVOSBASE_CURVA
} from '../const/servicesURI';
import requestService from './requestService';
import { httpRequests } from 'investira.sdk';
import utils from '../utils';

const cancel = {
  read: null,
  list: null,
  mercado: null,
  curva: null
};

export const read = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.read) {
    cancel.read.cancel();
  }

  cancel.read = httpRequests.cancelToken();

  const xProps = {
    params: pProps.params,
    cancelToken: cancel.read.token
  };

  return requestService(xProps, ATIVOSBASE_READ + pProps.ifeed_ativo_id, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service AtivosBase Read');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const list = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.list.token
  };

  return requestService(xProps, ATIVOSBASE_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service AtivosBase List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const cotacao = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.cotacao) {
    cancel.cotacao.cancel();
  }

  cancel.cotacao = httpRequests.cancelToken();

  const xParams = {
    ...pParams,
    sort: 'data'
  };

  const xProps = {
    params: xParams,
    cancelToken: cancel.cotacao.token
  };

  return requestService(xProps, ATIVOSBASE_COTACAO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Ativos Cotação');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const mercado = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.list.token
  };

  return requestService(xProps, ATIVOSBASE_MERCADO, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service AtivosBase Mercado');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const curva = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.curva) {
    cancel.curva.cancel();
  }

  cancel.curva = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.curva.token
  };

  return requestService(xProps, ATIVOSBASE_CURVA, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service AtivosBase Curva');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const ativosbase = { list, read, cotacao, mercado, curva, cancel };

export default ativosbase;
